import React, { useState } from 'react';
import { useHistory } from "react-router-dom";

import { Config } from '../../public/js/config';
import './indexAbout.css';
import trans from './translation';

import loginLogoImg from '../../public/img/loginLogo.png';

const indexAbout = () => {

    const history = useHistory();

    return (
        <div className='indexAbout'>
            <div className='logoBox'>
            <img src={loginLogoImg} />
                <div className='helpLoginBtn sysUpdate' onClick={() => history.push("/login")}>{trans.login[Config.backLang]}</div>
            </div>
            <div className='line'></div>
            <div className='helpBackground'>
                <div className='helpBox'>
                    <div className='helpTitle'>About</div>
                    <div className='helpInfo'>This is an online interactive digital platform serving as a one-stop-shop resource center for THEi&apos;s Work-integrated Learning (WIL), to enable posting of WIL job opportunities, administrative filing and processing of WIL job applications, facilitate work-based learning and assessment engagement, and record keeping. Serving the user communities of Industry Partners, Students and Academic staff.</div>
                    <br></br>
                    <div className='helpInfo'>Access this link for more information about WIL : <a href='https://www.thei.edu.hk/industry-collaboration/work-integrated-learning-wil' target="_blank" rel="noreferrer">https://www.thei.edu.hk/industry-collaboration/work-integrated-learning-wil</a></div>
                </div>
            </div>
        </div>
    )
}

export default indexAbout;